// extracted by mini-css-extract-plugin
module.exports = {"si-wrapper":"PrivacyPolicy_si-wrapper__1mnte","silc-btn":"PrivacyPolicy_silc-btn__2GYT7","root":"PrivacyPolicy_root__2pBDF","lastUpdated":"PrivacyPolicy_lastUpdated__2zDLP"};